import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RolesManagementStore } from '../store/roles-management.store';
import { of, tap } from 'rxjs';
import { UsersManagementStore } from '../../users-management/store/users-management.store';

export const rolesManagementResolver: ResolveFn<boolean> = () => {
  const store = inject(RolesManagementStore);
  const userStore = inject(UsersManagementStore);

  return of(true).pipe(
    tap(() => {
      userStore.loadUsers();
      store.loadRoles();
      store.clearFilters('userFilter');
      store.clearSearch();
    }),
  );
};
